var _clientId = "";
var _clientSecret = "";
var _host = "";
var _token = "";
import $ from "jquery";
import { Decrypt } from "@/until/ZeusApiSDK/Logic/CryptoLogic";
class postProxyRequest {
  constructor(apiId, paras, data, refer) {
    this.apiId = apiId;
    this.postBody = {};
    this.postBody.paras = paras;
    this.postBody.data = data;
    this.refer = refer;
  }
}
class postProxyRequestNoparas {
  constructor(apiId, data, refer) {
    this.apiId = apiId;
    this.postBody = {};
    // this.postBody.paras = paras;
    this.postBody.data = data;
    this.refer = refer;
  }
}
function InitClient(clientId, ClientSecret, host) {
  _clientId = clientId;
  _clientSecret = ClientSecret;
  if (!_host) {
    var rnd = getRndInteger(0, 1);
    _host = host[rnd];
  }
  return _host;
}
function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
//获取token
function GetToken() {
  var appinfo = JSON.parse(Decrypt(window.sessionStorage.getItem("appInfo")));

  if (_token) {
    return _token; //_host
  } else {
    $.ajax({
      url: _host + "/token",
      type: "POST",
      async: false,
      contentType: "application/x-www-form-urlencoded",
      Accept: "application/json",
      data:
        "grant_type=client_credentials&client_id=" +
        appinfo.clientId +
        "&client_secret=" +
        appinfo.clientSecret,
      success: function (res) {
        _token = res.access_token;
      },
      error: function (a, b, c) { }
    });
    return _token;
  }
}
function GetCurrentTiket(token) {
  var user;
  $.ajax({
    url: "http://pw.ruizhiqi.cn/api/app/GetCurrentTicket?token=" + token,
    type: "GET",
    async: false,
    Accept: "application/json",
    success: function (res) {
      user = res;
    },
    error: function (error, xhr, aaa) {
      console.log("第一个", error);
      console.log("第二个", xhr);
      console.log("第三个", aaa);
    }
  });
  return user;
}
//发送请求到代理，统一方法
function PostProxy(request) {
  //此处的request就是使用postProxyRequest 构造
  return new Promise(function (resolve, reject) {
    var token = GetToken();
    var data;
    $.ajax({
      url: _host + "/api/proxy/" + request.apiId + "/" + request.refer,
      type: "POST",
      Accept: "application/json",
      contentType: "application/json",
      beforeSend: function (request) {
        request.setRequestHeader("Authorization", "bearer " + token);
      },
      data: JSON.stringify(request.postBody),
      success: function (res) {
        //401为身份验证失败，重新获取token，再发起请求；
        res = JSON.parse(res);
        if (res.Code == "401") {
          _token = "";
          PostProxy(request);
        } else if (res.Code == "500") {
          resolve((res.Data = { Result: 500 }));
        } else {
          if (res.Code == "200") {
            resolve(res.Data);
          } else {
            reject(res.ErrorMessage);
          }
        }
      },
      error: function (e, xhr, opt) {
        if (e.status == 401) {
          _token = "";
          PostProxy(request);
        } else if (e.status == 400) {
          reject(e.responseText);
        }
      }
    });
  });
}

//GET请求
async function GetByParas(apiId, paras) {
  var request = new postProxyRequest(apiId, paras, "", "");
  return await PostProxy(request);
}
//Post请求带url参数
async function PostWithParas(apiId, paras, data) {
  var request = new postProxyRequest(apiId, paras, data, "");
  return await PostProxy(request);
}

//post只有bodydata
async function Post(apiId, data) {
  var request = new postProxyRequest(apiId, "", data, "");
  return await PostProxy(request);
}
//post只有bodydata,无paras 付亚楠添加
async function PostNoParas(apiId, data) {
  var request = new postProxyRequestNoparas(apiId, data, "");
  return await PostProxy(request);
}
async function Unlogin(token, url) {
  $.ajax({
    url: "http://pw.ruizhiqi.cn/SSOLogin/unlogin",
    type: "POST",
    async: false,
    contentType: "application/json",
    Accept: "application/json",
    data: {
      token: token,
      url: url
    },
    success: function (res) { }
  });
}
export {
  InitClient,
  GetByParas,
  PostWithParas,
  Post,
  PostNoParas,
  Unlogin,
  GetCurrentTiket,
  getRndInteger
};
